import React from 'react';
import '../../styles/theme.css';

interface Tab {
    id: string;
    title: string;
}

interface TabsComponentProps {
    onTabChange: (tabId: string) => void;
    activeTab: string;
}

const tabs: Tab[] = [
    { id: 'stat', title: 'Statistik' },
    { id: 'team', title: 'Hold' },
    { id: 'matches', title: 'Kampe' },
    { id: 'achievements', title: 'Præstationer' },
    { id: 'clips', title: 'Clips' },
    { id: 'positioner', title: 'Roller og Positioner' }
];

/**
 * The only tab ids the player page renders. Exported so a ?tab= value from a URL can be validated
 * before it is trusted - an unknown id matches no panel and renders a blank page.
 */
export const PLAYER_TAB_IDS = tabs.map(t => t.id);

const TabItem: React.FC<{ tab: Tab; isActive: boolean; onClick: (id: string) => void }> = ({ tab, isActive, onClick }) => (
    <li className="nav-item" role="presentation">
        <button
            className={`nav-link ${isActive ? 'active' : ''} m-1`}
            id={`pills-${tab.id}-tab`}
            data-bs-toggle="pill"
            data-bs-target={`#pills-${tab.id}`}
            type="button"
            role="tab"
            aria-controls={tab.id}
            aria-selected={isActive}
            onClick={() => onClick(tab.id)}
            style={{
                background: isActive
                    ? 'linear-gradient(135deg, #ff6600, #ff9933)'
                    : 'rgba(255, 255, 255, 0.05)',
                color: isActive
                    ? '#ffffff'
                    : 'rgba(255, 255, 255, 0.8)',
                border: isActive
                    ? '1px solid transparent'
                    : '1px solid rgba(255, 102, 0, 0.2)',
                borderRadius: '8px',
                padding: 'clamp(8px, 2vw, 10px) clamp(12px, 3vw, 20px)',
                fontSize: 'clamp(0.8rem, 2.5vw, 1rem)',
                fontWeight: '600',
                transition: 'background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1), color 0.3s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                cursor: 'pointer',
                position: 'relative',
                overflow: 'hidden',
                boxShadow: isActive
                    ? '0 1px 4px rgba(255, 102, 0, 0.1)'
                    : 'none',
                whiteSpace: 'nowrap'
            }}
            onMouseEnter={(e) => {
                if (!isActive) {
                    e.currentTarget.style.background = 'rgba(255, 102, 0, 0.1)';
                    e.currentTarget.style.borderColor = 'rgba(255, 102, 0, 0.4)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 2px 6px rgba(255, 102, 0, 0.1)';
                    e.currentTarget.style.color = '#ff9933';
                }
            }}
            onMouseLeave={(e) => {
                if (!isActive) {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                    e.currentTarget.style.borderColor = 'rgba(255, 102, 0, 0.2)';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                    e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)';
                }
            }}
        >
            {tab.title}
        </button>
    </li>
);

const TabsComponent: React.FC<TabsComponentProps> = ({ onTabChange, activeTab }) => {

    const handleTabClick = (tabId: string) => {
        onTabChange(tabId);
    };

    return (
        <div className="d-flex align-items-center justify-content-center">
            <ul className="nav nav-pills" id="pills-tab" role="tablist">
                {tabs.map((tab) => (
                    <TabItem
                        key={tab.id}
                        tab={tab}
                        isActive={tab.id === activeTab}
                        onClick={handleTabClick}
                    />
                ))}
            </ul>
        </div>
    );
};

export default TabsComponent;